<template>
  <footer id="main_footer">
    <img src="../../assets/images/waveOk.svg" alt="" />
    <div class="column footer-content-background">
      <div class="footer-content">
        <div class="logo-center">
          <a href="/" target="_blank">
            <img src="../../assets/images/stratumblue_white_outline_logo.png" />
          </a>
          <p>© {{ year }} {{ $tc("msg.all_rights_reserved", 1) }}</p>
        </div>
        <ul>
          <li>
            <a href="/" target="_blank">{{ $tc("msg.home", 1) }}</a>
          </li>
          <li>
            <a href="https://bluetoken.io/Faqs" target="_blank">{{
              $tc("msg.faq", 1)
            }}</a>
          </li>
          <li>
            <a target="_blank" href="https://bluetoken.io/Terms">{{
              $tc("msg.terms_and_conditions", 1)
            }}</a>
          </li>
          <li>
            <a href="https://bluetoken.io/Privacy" target="_blank">{{
              $tc("msg.privacy_policy", 1)
            }}</a>
          </li>
          <li>
            <a href="https://bluetoken.io/Fees" target="_blank">{{
              $t("msg.fees_minimums")
            }}</a>
          </li>
          <li>
            <a
              href="https://bscscan.com/token/0xE2F3Db52F7065220e113014f23f5DD4c7bafBAc2"
              target="_blank"
              >{{ $t("msg.explorer") }}</a
            >
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import spacetime from "spacetime";
export default {
  data: () => ({
    year: spacetime.now().year(),
  }),
};
</script>





// WEBPACK FOOTER //
// src/components/public/BaseFooter.vue